module.exports = __webpack_public_path__ + "static/media/Carousel-clamps.f37070cb.png";